import React, { useCallback } from "react";
import { getLocalizedText, getClassNames } from "data/utils";
import ClearableInput from "@hs/clearable-input";
import { withFormsy } from "formsy-react";
import styles from "./Input.module.css";

type Props = {
    /** callback when user changes search text
     * @param {string} searchText search text
     */
    onChange: (searchText: string) => void,
    /** formsy callback to set value
     * @param {string} searchText search text
     */
    setValue?: (searchText: string) => void,
    /** CSS classname */
    className?: string,
    /** Components children */
    children?: React$Node,
};

const Input = ({ className, children, setValue, onChange, ...rest }: Props) => {
    const handleChange = useCallback(
        (value) => {
            /* istanbul ignore else */
            if (typeof setValue === "function") setValue(value);
            /* istanbul ignore else */
            if (typeof onChange === "function") onChange(value);
        },
        [setValue, onChange]
    );
    const {
        validate,
        showRequired,
        showError,
        setValidations,
        resetValue,
        isValid,
        isRequired,
        isPristine,
        isFormSubmitted,
        hasValue,
        innerRef,
        runValidation,
        isValidValue,
        isFormDisabled,
        detachFromForm,
        attachToForm,
        validationError,
        validationErrors,
        errorMessage,
        errorMessages,
        ...props
    } = rest;
    return (
        <div className={getClassNames(className, styles.wrapper)}>
            <ClearableInput
                inputRef={innerRef}
                type="search"
                placeholder={getLocalizedText("$search.emptyText")}
                onChange={handleChange}
                {...props}
            />
            {children}
        </div>
    );
};
Input.displayName = "SearchMask.Input";
export const InputWithFormsy = withFormsy(Input);
export default Input;
